/** Mirrors the backend UserRole enum. Every user always holds USER. */
export const ROLES = {
    USER: "USER",
    EMPLOYEE: "BUSINESS_EMPLOYEE",
    BUSINESS: "BUSINESS_ADMIN",
    ADMIN: "ADMINISTRATOR",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/** Mirrors the backend EmployeePermission enum. Granted per business, to employees. */
export const PERMISSIONS = {
    TICKETS: "TICKETS",
    WALLET: "WALLET",
    CASHLESS: "CASHLESS",
    SALES: "SALES",
    ADMIN: "ADMIN",
} as const;

export type EmployeePermission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
